export const environment = {
  production: true,
  mapBoxToken:
    'pk.eyJ1IjoiZWRnYXJvc28iLCJhIjoiY2wweTM4NTFhMGR5eDNqcGptanV5aHp4aSJ9.KLCQka6moBKdKra6Xw1nZA',

  urlIp: 'Https://taxismedellin.com.co:3001', // SERVIDOR DE TAXIS MEDELLIN
};
